/* import __COLOCATED_TEMPLATE__ from './event-details.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ENV from 'bullitttime-event/config/environment';

export default class EventDetailsComponent extends Component 
{
	@service store;

	get exportPath()
	{
		var event = this.args.event;
		return ENV.eventBackendProtocol+"://"+ENV.eventBackendHost+":"+ENV.eventBackendPort+(ENV.eventBackendNamespace ? "/"+ENV.eventBackendNamespace : "")+"/events/"+event.id+"/export"
	};
	
	@action
	async togglePhotoFinish(event)
	{
		this.args.event.usePhotoFinish = event.target.checked;
		try
		{
			await this.args.event.save();
		}
		catch (error)
		{
			alert(error)
			this.args.event.rollbackAttributes();
		}
	}
	
	@action
	async toggleIndividualCourses(event)
	{
		this.args.event.useIndividualCourses = event.target.checked;
		try
		{
			await this.args.event.save();
		}
		catch (error)
		{
			alert(error)
			this.args.event.rollbackAttributes();
		}
	}
	
	@action
	async eventPrecisionChanged(browserEvent)
	{
		var event = this.args.event;
		
		event.precision = browserEvent.target.value;
		try
		{
			await this.args.event.save();
		}
		catch (error)
		{
			alert(error)
			this.args.event.rollbackAttributes();
		}
	};
	
	@action
	async dateChanged(newDate)
	{
		var event = this.args.event;
		
		event.date = newDate[0];
		try
		{
			await this.args.event.save();
		}
		catch (error)
		{
			alert(error)
			this.args.event.rollbackAttributes();
		}
	};
}